import { Theme, useTheme } from "@amx/ux-twoui-theming";
import { ICalloutProps, TooltipHost as FluentTooltipHost } from "@fluentui/react";
import React from "react";
import { AnchorPosition, anchorPositionToFluentMapping } from "../../shared/constants";
import { useComponentLogger } from "../../shared/logging";
import { BaseProps } from "../../shared/props";

export interface TooltipHostProps extends BaseProps {
    /**
     * Tooltip text content
     */
    readonly tooltipText: string | JSX.Element;

    /**
     * How the Tooltip should be anchored to its target element
     */
    readonly tooltipPosition?: AnchorPosition;
}

const calloutProps = (theme: Theme): ICalloutProps => ({
    backgroundColor: theme.palette.neutralHigh,
    styles: {
        beakCurtain: {
            backgroundColor: theme.palette.neutralHigh
        },
    }
});

export const TooltipHost: React.FC<TooltipHostProps> = ({
    children,
    tooltipText,
    tooltipPosition
}) => {
    useComponentLogger("TooltipHost");

    const theme = useTheme();

    return (
        <FluentTooltipHost
            directionalHint={anchorPositionToFluentMapping[tooltipPosition || "top-center"]}
            content={tooltipText}
            calloutProps={calloutProps(theme)}
        >
            {children}
        </FluentTooltipHost>
    );
};
